import { IonItem } from "@ionic/react";
import type { ListLink as LinkListProps, ListProps, ResponsiveChooice } from "../../types";
import React, { ReactNode, useEffect, useMemo } from "react";
import listStyle from "../../List.module.scss";
import ItemContainerSlider from "../../../Settings/SettingsComponents/SettingsItemSlider/ItemContainerSlider/ItemContainerSlider";
import { useIsMobile } from "../../../Responsive";
import { Link } from "react-router-dom";
import LongPress from "../../../LongPress";
import { useNamedRoutes } from "../../../NamedRoutes";
import Icon from "@ews/react-icons";
import { Col } from "./Col";
// import { NoContent } from "../RowContainer/RowContainer";

import { useL10n } from "@ews/react-localization-context";

export const NoContent = () =>
{
    const { translate: t } = useL10n();

    return <IonItem data-testid="no-content" className={listStyle.noContent} lines={'full'}><div>{t('[REACT_NO_CONTENT]')}</div></IonItem>;
};


export type RowProps = Pick<ListProps, "link" | "headers" | "rowClass" | "sliderChildren" | "onClick" | "noLink"> &
{
    row: Record<string, any>,
    index: number,
    onMenu: (id: string, e: any, params: Record<string, any>) => void;
    hasMenu: boolean;
};

const ListLink: React.FC<LinkListProps> = ({ style, listref, className, to, children, noLink }) => (!noLink && to) ?
    <Link
        data-testid="list-link"
        style={style}
        ref={listref}
        className={className}
        to={to!}
    >{children}</Link>
    :
    <>{children}</>;


const optionChoiceList = (choiceList: any[][], data: string) =>
{

    if (!choiceList.length) return new Error('the choiceList is empty');

    const choice = choiceList.filter((choiceItem) => choiceItem[0] === data);

    return choice.length ? choice[0][1] : [];
};

export const Row: React.FC<RowProps> = ({
    link,
    headers,
    row,
    rowClass,
    sliderChildren,
    noLink,
    index,
    hasMenu,
    onMenu,
    onClick,
}) =>
{

    const { generate } = useNamedRoutes();

    const mobileView = useIsMobile();

    if (!Object.keys(row).length) {
        if (row.length === index + 1) return <NoContent key={index} />;
        return null;
    };

    const _rowClass = row.className || (rowClass || "");

    const Container = sliderChildren ? IonItem : ({ children }: { children: ReactNode; }) => <React.Fragment>{children}</React.Fragment>;

    const evenOdd = (index) % 2 ? 'even' : 'odd';

    const params = link ?
        link.paramsKey.includes(",") ?
            link.paramsKey.split(",").reduce((acc, key) =>
            {
                key = key.trim();
                if (key.includes(" as ")) {
                    const [originKey, assertion] = key.split(" as ");
                    acc[assertion] = row[originKey as keyof typeof row];
                } else {
                    acc[key] = row[key as keyof typeof row];
                }
                return acc;
            }, {} as Record<string, any>)

            : { [link.paramsKey!]: row[link.paramsKey!] }
        : { noLink: true };

    return (
        <ItemContainerSlider key={`slider-${index}-${row.id}`} >

            {sliderChildren}

            <Container data-testid="list-row" lines="none" className={listStyle.container}>
                <section
                    onClick={() => onClick && onClick(row)}
                    className={`${mobileView ? listStyle.mobile : ''} ${_rowClass} ${row.link ? listStyle.pointer : ''}`}
                >
                    <ListLink
                        //listref={linkRef}
                        className={listStyle.link}
                        noLink={noLink}
                        key={index}
                        to={link ? generate(link.url, params) : row.link || ''}
                    >
                        <div
                            className={`${listStyle.row} ${hasMenu ? listStyle.menu : ""}  ${listStyle[evenOdd]} ${mobileView ? listStyle.pullUp : ''}`}

                            {...LongPress((e) => hasMenu && onMenu(row.id, e, params))}
                            onContextMenu={(e) =>
                            {

                                e.preventDefault();
                                hasMenu && onMenu(row.id, e, params);
                            }}
                        >
                            {!mobileView && hasMenu ? <div
                                className={`${listStyle.col} ${listStyle.settingsIcon} ${listStyle.center}`}
                                onClick={(e) =>
                                {
                                    e.preventDefault();
                                    onMenu(row.id, e, params);
                                }}
                            >
                                <Icon
                                    height={"34px"}
                                    width={"34px"}
                                    icon={"options"}
                                    color="danger"
                                />
                            </div> : null}

                            {headers.map((head, index) =>
                            {
                                let value: any = row[head.key as any];

                                let responsive: ResponsiveChooice = 'desktop';

                                if (head.breakpoint) responsive = 'breakpoint';
                                else if (head.desktop) responsive = 'desktop';
                                else if (head.mobile) responsive = 'mobile';
                                else responsive = 'both';

                                let choice: any = undefined;
                                if (head.option && head.option.choiceList) {

                                    const data = head.option.key ? row[head.option.key] : value;
                                    const option = optionChoiceList(head.option.choiceList, data);
                                    if (!(option instanceof Error)) choice = option;
                                };



                                if (head.child) {
                                    return <Col
                                        className={head.className || ""}
                                        key={`item-${index}`}
                                        value={head.child(row)}
                                        link={head?.option?.link}
                                        responsive={responsive}
                                        choice={choice}
                                        up={head.up}
                                        nextLine={head?.option?.nextLine}
                                        breakpoint={head.breakpoint || 0}
                                    />;

                                };

                                /* ------------------------------------------------
                                                Error handling
                                */
                                if (value === undefined || value === null) {
                                    value = '';
                                };
                                /* ------------------------------------------------*/
                                if (value.type && value.type === 'function') return value;

                                return <Col
                                    className={head.className || ""}
                                    key={`${value}-${index}`}
                                    value={value}
                                    link={head?.option?.link}
                                    responsive={responsive}
                                    choice={choice}
                                    up={head.up}
                                    nextLine={head?.option?.nextLine}
                                    breakpoint={head.breakpoint || 0}
                                />;
                            })}
                            {mobileView && hasMenu ? <div
                                className={`${listStyle.col} ${listStyle.settingsIcon} ${listStyle.mobile} ${listStyle.center}`}>

                                <Icon
                                    height={"30px"}
                                    width={"80px"}
                                    icon={"options"}
                                    color="danger"
                                    onClick={(e) =>
                                    {
                                        e.preventDefault();
                                        onMenu(row.id, e as unknown as React.MouseEvent<HTMLElement, MouseEvent>, params);
                                    }} />
                            </div> : null}
                        </div>
                    </ListLink>
                </section>
            </Container>
        </ItemContainerSlider>
    );
};
